const EMPTY_DESCRIPTION = { es: "", en: "", gl: "" };

export function normalizeServiceDescription(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { ...EMPTY_DESCRIPTION };
  }

  return {
    ...EMPTY_DESCRIPTION,
    ...value
  };
}

export function extractRelationIds(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .map(item => {
      if (item == null) {
        return null;
      }
      if (typeof item === "object") {
        return item.id !== undefined && item.id !== null ? item.id : null;
      }
      return item;
    })
    .filter(item => item != null);
}

export function normalizeService(service) {
  if (!service || typeof service !== "object") {
    return null;
  }

  return {
    ...service,
    host:
      service.host && typeof service.host === "object"
        ? {
            id:
              service.host.id !== undefined && service.host.id !== null
                ? service.host.id
                : null,
            hostname:
              service.host.hostname !== undefined &&
              service.host.hostname !== null
                ? service.host.hostname
                : ""
          }
        : service.host !== undefined && service.host !== null
          ? service.host
          : null,
    order:
      service.order === undefined || service.order === null
        ? 0
        : Number(service.order),
    hidden: service.hidden === true,
    available_in_forms: service.available_in_forms !== false,
    basic: service.basic === true,
    restricted: service.restricted === true,
    requires_agreement: service.requires_agreement === true,
    create_ldap_group: service.create_ldap_group === true,
    documentation_link: service.documentation_link || "",
    description: normalizeServiceDescription(service.description),
    contact_people: Array.isArray(service.contact_people)
      ? service.contact_people.filter(Boolean)
      : [],
    exclusive_with: extractRelationIds(service.exclusive_with)
  };
}

export function normalizeServices(services) {
  if (!Array.isArray(services)) {
    return [];
  }

  return services.map(normalizeService).filter(Boolean);
}
